import { useEffect } from 'react';

import { config } from 'components/pages/Epg/config';
import { throttle } from 'components/pages/Epg/utils';

import { useToggleScrollDirection } from '../useToggleScrollDirection/useToggleScrollDirection';

export const useDateViewScrollDirection = () => {
  const toggleScrollDirection = throttle(useToggleScrollDirection(), config.delayForVerticalScroll);

  useEffect(() => {
    window.addEventListener('scroll', toggleScrollDirection);

    return () => {
      window.removeEventListener('scroll', toggleScrollDirection);
    };
  }, []);
};
